import { cn } from "@/lib/utils";

/** Mastermind Space row in library navigation */
export const spaceNavRowClassName = cn(
  "group flex items-center gap-1 px-2 py-1.5 rounded-md cursor-pointer transition-colors",
  "hover:bg-purple-50 dark:hover:bg-purple-950/40",
  "bg-purple-50/60 dark:bg-purple-950/25 border border-purple-100 dark:border-purple-900/50"
);

export const spaceNavRowSelectedClassName = cn(
  spaceNavRowClassName,
  "bg-purple-100 dark:bg-purple-900/30 border-purple-200 dark:border-purple-700"
);

export const spaceNavLabelClassName = "text-sm font-semibold truncate flex-1 min-w-0";

/** Library folder row */
export const folderNavRowClassName =
  "group flex items-center gap-1 px-2 py-1.5 rounded-md cursor-pointer hover:bg-accent transition-colors min-w-0";

export const folderNavRowSelectedClassName = cn(
  folderNavRowClassName,
  "bg-primary/10 border border-primary/30 shadow-sm"
);

export const folderNavLabelClassName = "text-sm truncate flex-1 min-w-0";

/** Topic filter pill (not a folder) */
export const topicPillClassName = cn(
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium cursor-pointer transition-colors",
  "bg-muted hover:bg-muted/80 text-foreground border border-border"
);

export const topicPillSelectedClassName = cn(
  topicPillClassName,
  "bg-primary/10 border-primary/30 text-primary"
);

/** Topic row under a space — full width for drag-and-drop targets */
export const topicNavRowClassName = cn(
  "flex items-center gap-1 w-full min-w-0 rounded-md transition-colors",
  "hover:bg-muted/60"
);

export const topicNavRowSelectedClassName = cn(
  topicNavRowClassName,
  "bg-primary/10 ring-1 ring-primary/25"
);

export const librarySectionHeadingClassName =
  "text-xs font-medium uppercase tracking-wide text-muted-foreground mb-2";
